import { useCallback, useMemo } from 'react';
import type { GridSortModel } from '@mui/x-data-grid';
import { ArrayParam, useQueryParams } from 'use-query-params';
import { toSortModel, toSortParams } from '../utils';

const QUERY_PARAMS = { sort: ArrayParam, order: ArrayParam };

/**
 * Grid sort kept in the `sort` / `order` URL params (the same values the list request sends), so it
 * survives a reload and can be shared. Without the params the default sort applies and the URL stays clean.
 */
const useSortParams = () => {
  const [query, setQuery] = useQueryParams(QUERY_PARAMS);
  const sortKey = (query.sort ?? []).join(',');
  const orderKey = (query.order ?? []).join(',');

  const sortModel = useMemo(
    () => toSortModel(sortKey ? sortKey.split(',') : [], orderKey ? orderKey.split(',') : []),
    [orderKey, sortKey],
  );

  const setSortModel = useCallback(
    (model: GridSortModel) => {
      const { sort, order } = toSortParams(model);
      setQuery({ sort, order: order?.map(String) }, 'replaceIn');
    },
    [setQuery],
  );

  return { sortModel, setSortModel };
};

export default useSortParams;
